var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-main',[_c('div',{staticClass:"home"},[_c('div',{staticClass:"subheader"},[_c('div',{staticClass:"subheader-main"},[_c('h3',[_vm._v(" "+_vm._s(_vm.$t('labels.statistics'))+" ")]),_c('span',{staticClass:"separator-line"}),_c('div',{staticClass:"breadcrumbs"},[_c('router-link',{staticClass:"breadcrumbs-link",attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t('labels.home')))]),_c('span',{staticClass:"separator-dot"}),_c('router-link',{staticClass:"breadcrumbs-link",attrs:{"to":"/tickets/statistics"}},[_vm._v(" "+_vm._s(_vm.$t('labels.statistics')))])],1)])]),_c('reactive-base',{attrs:{"app":"ticket_index","credentials":_vm.user.user.es_username + ':' + _vm.user.user.es_password,"url":_vm.elasticUrl}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"widget"},[_c('div',{staticClass:"widget-header statistics-filter"},[_c('div',{staticClass:"widget-header-label"},[_c('h3',[_vm._v(_vm._s(_vm.$t('labels.selected-filters')))])]),_c('div',{staticClass:"widget-header-toolbar"},[_c('div',{staticClass:"actions"},[_c('SelectedFilters',{staticClass:"bb-1 curent-filters pl-4 m-0",attrs:{"clearAllLabel":this.$t('labels.clear')}})],1)])])])]),_c('v-guard',{attrs:{"permissions":['tickets-page-statistics-use-filter']}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"widget"},[_c('div',{staticClass:"widget-header statistics-filter"},[_c('multi-list',{attrs:{"componentId":"yearFilter","filterLabel":this.$t('labels.year'),"title":this.$t('labels.year'),"dataField":"year.raw","className":"horizontal-filter","sortBy":"asc","showSearch":false,"URLParams":true,"react":{ and: _vm.getOtherFilterIds('yearFilter') }},on:{"valueChange":_vm.setSelectedYears},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
return [_c('div',[_vm._v(_vm._s(label))])]}}])}),_c('multi-list',{attrs:{"componentId":"quarterFilter","filterLabel":this.$t('labels.quarter'),"title":this.$t('labels.quarter'),"dataField":"quarter.raw","className":"horizontal-filter","sortBy":"asc","showSearch":false,"URLParams":true,"react":{ and: _vm.getOtherFilterIds('quarterFilter') }},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
return [_c('div',[_vm._v(" "+_vm._s(label)+" ")])]}}])}),_c('multi-list',{attrs:{"componentId":"monthFilter","filterLabel":this.$t('labels.month'),"title":this.$t('labels.month'),"dataField":"month.raw","className":"horizontal-filter","sortBy":"asc","size":12,"showSearch":false,"URLParams":true,"transformData":_vm.sortMonthByLabel,"react":{ and: _vm.getOtherFilterIds('monthFilter') }},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
var count = ref.count;
return [_c('div',[_vm._v(" "+_vm._s(_vm.renameMonthsLabel(label))+" ")])]}}])})],1)])]),_c('div',{staticClass:"col-lg-12 col-xl-3 order-lg-1 order-xl-1"},[_c('div',{staticClass:"widget widget-facets statistics-vertical"},[_c('div',{staticClass:"widget-header mb-3"},[_c('div',{staticClass:"widget-header-label"},[_c('h3',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"fas fa-circle-notch fa-spin"}),_vm._v(_vm._s(_vm.$t('labels.filtration')))])]),_c('div',{staticClass:"widget-header-toolbar"},[_c('div',{staticClass:"actions"})])]),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.gender'),"componentId":"genderFilter","filterLabel":this.$t('labels.gender'),"dataField":this.$field('gender') + '.raw',"react":{ and: _vm.getOtherFilterIds('genderFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.age-group'),"componentId":"ageFilter","filterLabel":this.$t('labels.age-group'),"dataField":this.$field('age') + '.raw',"transformData":_vm.customSortAge,"react":{ and: _vm.getOtherFilterIds('ageFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"categoryFilter","filterLabel":this.$t('labels.category'),"title":this.$t('labels.category'),"dataField":this.$field('category') + '.raw',"react":{ and: _vm.getOtherFilterIds('categoryFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.first-contact'),"componentId":"firstContactFilter","filterLabel":this.$t('labels.first-contact'),"dataField":this.$field('first_contact') + '.raw',"react":{ and: _vm.getOtherFilterIds('firstContactFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"crimeFilter","size":300,"title":this.$t('labels.crime'),"filterLabel":this.$t('labels.crime'),"dataField":this.$field('crime') + '.raw',"react":{ and: _vm.getOtherFilterIds('crimeFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.special-circumstances'),"componentId":"crimeRelationSubFilter","filterLabel":this.$t('labels.special-circumstances'),"nestedField":"crime_relation","dataField":this.$field('crime_relation.label') + '.raw',"react":{ and: _vm.getOtherFilterIds('crimeRelationSubFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.special-events'),"componentId":"specialEventSubFilter","filterLabel":this.$t('labels.special-events'),"dataField":this.$field('special_event') + '.raw',"react":{ and: _vm.getOtherFilterIds('specialEventSubFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"riskFilter","title":this.$t('labels.increased-risk'),"filterLabel":this.$t('labels.risk'),"dataField":this.$field('risk') + '.raw',"react":{ and: _vm.getOtherFilterIds('riskFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":1000,"title":this.$t('labels.language'),"componentId":"languageFilter","filterLabel":this.$t('labels.language'),"dataField":this.$field('language') + '.raw',"react":{ and: _vm.getOtherFilterIds('languageFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":1000,"componentId":"officeFilter","title":this.$t('labels.victim-support-centre'),"filterLabel":this.$t('labels.victim-support-centre'),"dataField":"office.raw","react":{ and: _vm.getOtherFilterIds('officeFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":1000,"componentId":"localofficeFilter","filterLabel":this.$t('labels.local-office'),"title":this.$t('labels.local-office'),"dataField":"localoffice.raw","react":{ and: _vm.getOtherFilterIds('localofficeFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":1000,"componentId":"municipalityFilter","title":this.$t('labels.municipality'),"filterLabel":this.$t('labels.municipality'),"dataField":"municipality.raw","react":{ and: _vm.getOtherFilterIds('municipalityFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":1000,"componentId":"userSubFilter","title":this.$t('labels.administrator'),"filterLabel":this.$t('labels.administrator'),"nestedField":"users","dataField":"users.name.raw","react":{ and: _vm.getOtherFilterIds('userSubFilter') }}})],1)])])]),_c('div',{staticClass:"col-lg-12 col-xl-9 order-lg-1 order-xl-1"},[_c('reactive-component',{attrs:{"componentId":"myColorPicker","URLParams":true,"react":{ and: _vm.getOtherFilterIds('') },"defaultQuery":function () { return ({
								runtime_mappings: {
									'date.month_of_years': {
										type: 'long',
										script: 'emit(doc[\'created_at\'].value.getMonthValue())'
									}
								},
								aggs: {
									crimes: {
										terms: {
											field: this$1.$field('crime') + '.raw',
											order: {
												_key: 'asc'
											},
											size: 100,
										},
										aggs: {
											year: {
												terms: {
													field: 'year.raw',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												},
												aggs: {
													gender: {
														terms: {
															field: 'gender.raw',
															order: {
																_key: 'asc'
															},
															size: 100,
														},
													},
												},
											},
										},
									},
									office: {
										terms: {
											field: 'office.raw',
											order: {
												_key: 'asc'
											},
											size: 100,
										},
										aggs: {
											year: {
												terms: {
													field: 'year.raw',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												},
											},
										},
									},
									localoffice: {
										terms: {
											field: 'localoffice.raw',
											order: {
												_key: 'asc'
											},
											size: 100,
										},
										aggs: {
											year: {
												terms: {
													field: 'year.raw',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												},
											},
										},
									},
									age: {
										terms: {
											field: this$1.$field('age') + '.raw',
											order: {
												_key: 'asc'
											},
										},
										aggs: {
											year: {
												terms: {
													field: 'year.raw',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												},
											},
										},
									},
									gender: {
										terms: {
											field: this$1.$field('gender') + '.raw',
											order: {
												_key: 'asc'
											},
										},
										aggs: {
											year: {
												terms: {
													field: 'year.raw',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												},
											},
										},
									},
									month: {
										terms: {
											field: 'date.month_of_years',
											order: {
												_key: 'asc'
											},
											size: 100,
										},
										aggs: {
											year: {
												terms: {
													script: 'if (doc[\'created_at\'].size() != 0) doc[\'created_at\'].value.getYear()',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												}
											}
										}
									},
									quarter: {
										terms: {
											field: 'quarter.raw',
											order: {
												_key: 'asc'
											},
										},
										aggs: {
											year: {
												terms: {
													field: 'year.raw',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												},
											},
										},
									},
									category: {
										terms: {
											field: this$1.$field('category') + '.raw',
											order: {
												_key: 'asc'
											},
										},
										aggs: {
											year: {
												terms: {
													field: 'year.raw',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												},
											},
										},
									},
									language: {
										terms: {
											field: this$1.$field('language') + '.raw',
											order: {
												_key: 'asc'
											},
											size: 100,
										},
										aggs: {
											year: {
												terms: {
													field: 'year.raw',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												},
											},
										},
									},
									municipality: {
										terms: {
											field: 'municipality.raw',
											order: {
												_key: 'asc'
											},
											size: 1000,
										},
										aggs: {
											year: {
												terms: {
													field: 'year.raw',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												},
											},
										},
									},
									users: {
										nested: {
											path: 'users',
										},
										aggs: {
											user: {
												terms: {
													field: 'users.name.raw',
													order: {
														_key: 'asc'
													},
													size: 1000,
												},
												aggs: {
													reverted: {
														reverse_nested: {},
														aggs: {
															year: {
																terms: {
																	field: 'year.raw',
																	order: {
																		_key: 'asc'
																	},
																	min_doc_count: 0,
																	size: 1000,
																}
															}
														}
													}
												},
											},
										},
									},
									crime_relations: {
										nested: {
											path: 'crime_relation',
										},
										aggs: {
											relation: {
												terms: {
													field: 'crime_relation.label.raw',
													order: {
														_key: 'asc'
													},
													size: 100,
												},
												aggs: {
													reverted: {
														reverse_nested: {},
														aggs: {
															year: {
																terms: {
																	field: 'year.raw',
																	order: {
																		_key: 'asc'
																	},
																	min_doc_count: 0,
																	size: 100,
																}
															}
														}
													}
												},
											},
										},
									},
									firstcontact: {
										terms: {
											field: this$1.$field('first_contact') + '.raw',
											order: {
												_key: 'asc'
											},
										},
										aggs: {
											year: {
												terms: {
													field: 'year.raw',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												},
											},
										},
									},
									special_event: {
										terms: {
											field: this$1.$field('special_event') + '.raw',
											order: {
												_key: 'asc'
											},
										},
										aggs: {
											year: {
												terms: {
													field: 'year.raw',
													order: {
														_key: 'asc'
													},
													min_doc_count: 0,
													size: 100,
												},
											},
										},
									},
								},
							}); }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
							var aggregations = ref.aggregations;
							var hits = ref.hits;
							var setQuery = ref.setQuery;
return _c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.quarter.buckets,"title":_vm.$t('labels.quarter')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.month.buckets,"title":_vm.$t('labels.month')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.gender.buckets,"title":_vm.$t('labels.gender')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":_vm.customSortAge(aggregations.age.buckets),"title":_vm.$t('labels.age-group')}},[_vm._v(">")])],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.category.buckets,"title":_vm.$t('labels.category')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.firstcontact.buckets,"title":_vm.$t('labels.first-contact')}},[_vm._v(">")])],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.crimes.buckets,"title":_vm.$t('labels.crime')}},[_vm._v(">")])],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.crime_relations.relation.buckets,"title":_vm.$t('labels.special-circumstances')}},[_vm._v(">")])],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.special_event.buckets,"title":_vm.$t('labels.special-events')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.language.buckets,"title":_vm.$t('labels.language')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.office.buckets,"title":_vm.$t('labels.victim-support-centre')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.localoffice.buckets,"title":_vm.$t('labels.local-office')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.municipality.buckets,"title":_vm.$t('labels.municipality')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.users.user.buckets,"infoBox":'Ärenden avd Statistik - aggregerat fält Handläggare rubrik',"title":_vm.$t('labels.administrator')}})],1)])])}}])})],1)],1)]),_c('ScrollTopArrow')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }